'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _baguetteBox = require('./baguetteBox.js');

var _baguetteBox2 = _interopRequireDefault(_baguetteBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gallery = function gallery($, baguetteBox, blockId) {
    var mediaBlock = $('#' + blockId),
        prevLink = mediaBlock.find('.slideShow__pager-prev'),
        nextLink = mediaBlock.find('.slideShow__pager-next'),
        captionWrapper = mediaBlock.find('.slideShow__textHolder'),
        currentInfoWrapper = mediaBlock.find('.slideShow__pager-current'),
        slideShow = mediaBlock.find('.slideShow').length > 0 ? mediaBlock.find('.slideShow') : mediaBlock,
        currentPreImageElement = slideShow.children('a:visible'),
        totalImages = slideShow.children('a').length;

    prevLink.click(function (e) {
        e.preventDefault();
        currentPreImageElement = slideShow.children('a').filter(function (index, elem) {
            return $(elem).css('display') !== 'none';
        });
        if (currentPreImageElement.index() > 0) {
            currentInfoWrapper.html(currentInfoWrapper.html() * 1 - 1);
            currentPreImageElement.hide().prev().show();
            captionWrapper.html(currentPreImageElement.prev().data('caption'));
            if (currentPreImageElement.prev().data('caption') === '') {
                captionWrapper.hide();
            } else {
                captionWrapper.show();
            }

            if (currentPreImageElement.index() === 1) {
                prevLink.addClass('disabled');
            }
            if (currentPreImageElement.index() + 2 !== totalImages) {
                nextLink.removeClass('disabled');
            }
        }

        return false;
    });

    nextLink.click(function (e) {
        e.preventDefault();
        currentPreImageElement = slideShow.children('a').filter(function (index, elem) {
            return $(elem).css('display') !== 'none';
        });
        if (currentPreImageElement.index() + 1 < totalImages) {
            currentInfoWrapper.html(currentInfoWrapper.html() * 1 + 1);
            currentPreImageElement.hide().next().show();
            captionWrapper.html(currentPreImageElement.next().data('caption'));
            if (currentPreImageElement.next().data('caption') === '') {
                captionWrapper.hide();
            } else {
                captionWrapper.show();
            }

            if (currentPreImageElement.index() + 2 === totalImages) {
                nextLink.addClass('disabled');
            }
            if (currentPreImageElement.index() >= 0) {
                prevLink.removeClass('disabled');
            }
        }

        return false;
    });

    (function () {
        if (currentPreImageElement.data('caption') === '') {
            captionWrapper.hide();
        }

        if (totalImages !== 1) {
            nextLink.removeClass('disabled');
        }

        slideShow.find('a').each(function (num, elem) {
            $(elem).removeAttr('onClick');
        });
        slideShow.children('svg').on('click', function (event) {
            $(event.currentTarget).parent().children('a:visible')[0].click();
        });
    })();

    var options = {
        captions: true, // true|false|callback(element) - Display image captions
        buttons: true, // 'auto'|true|false - Display buttons
        animation: 'slideIn', // 'slideIn'|'fadeIn'|false - Animation type
        afterShow: function afterShow() {}, // callback - To be run after showing the overlay
        afterHide: null, // callback - To be run after hiding the overlay
        onChange: function onChange(index, total) {
            $('#baguetteBox-num').html(index + 1 + ' of ' + total);

            var $curEl = $('#baguetteBox-slider .full-image:eq(' + index + ')');
            $curEl.find('figcaption').show();
            $curEl.siblings().find('figcaption').hide();

            if (index === 0) {
                $('#previous-button').addClass('disabled');
            } else {
                $('#previous-button').removeClass('disabled');
            }

            if (index + 1 === total) {
                $('#next-button').addClass('disabled');
            } else {
                $('#next-button').removeClass('disabled');
            }
        } // callback(currentIndex, imagesElements.length) - When image changes
    };

    var touchStartX, touch;
    var touchFlag = false;
    var touchStartHandler = function touchStartHandler(event) {
        touchStartX = event.changedTouches[0].pageX;
    };
    var touchMoveHandler = function touchMoveHandler(event) {
        if (touchFlag) {
            return;
        }

        touch = event.changedTouches[0] || event.touches[0];
        if (touch.pageX - touchStartX > 20) {
            event.preventDefault();
            touchFlag = true;
            prevLink.trigger('click');
        } else if (touch.pageX - touchStartX < -20) {
            event.preventDefault();
            touchFlag = true;
            nextLink.trigger('click');
        }
    };
    var touchEndHandler = function touchEndHandler(event) {
        touchFlag = false;
    };
    var clickHandler = function clickHandler(event) {
        event.preventDefault();
    };
    function startHandleTouch() {
        slideShow[0].addEventListener('touchstart', touchStartHandler, false);
        slideShow[0].addEventListener('touchmove', touchMoveHandler, false);
        slideShow[0].addEventListener('touchend', touchEndHandler, false);
        slideShow[0].addEventListener('click', clickHandler, false);
    }
    function stopHandleTouch() {
        slideShow[0].removeEventListener('touchstart', touchStartHandler, false);
        slideShow[0].removeEventListener('touchmove', touchMoveHandler, false);
        slideShow[0].removeEventListener('touchend', touchEndHandler, false);
        slideShow[0].removeEventListener('click', clickHandler, false);
    }

    var box = baguetteBox;
    box.run(slideShow === mediaBlock ? '#' + blockId : '#' + blockId + ' .slideShow', options);

    return {
        run: function run(newBlockId) {
            var slideShowSelector = $('#' + newBlockId + ' > .slideShow').length > 0 ? '#' + newBlockId + ' > .slideShow' : '#' + newBlockId;
            var slideShow = $(slideShowSelector);

            $(slideShow).children('svg').on('click', function () {
                $(slideShow).children('a:visible > img').trigger('click');
            });
            box.run(slideShowSelector, options);
        },
        destroy: function destroy() {
            box.destroy();
        },
        startHandle: startHandleTouch,
        stopHandle: stopHandleTouch
    };
};

exports.default = gallery;


//////////////////
// WEBPACK FOOTER
// ./public/js/storyLightBox.js
// module id = 712
// module chunks = 0